import { PaginationNumberItem } from './PaginationNumberItem';

// TODO: in v9, move styled() from PaginationNumberItem.jsx to here
export var StyledPaginationNumberItem = PaginationNumberItem;